module.exports = __webpack_public_path__ + "img/hr-branch-particle-24.bbb0295b.png";